export default class Poll {
	constructor(snapshot) {
		if (snapshot) {
			this.key = snapshot.key
			Object.assign(this, snapshot.val())
		}
	}

	get url() {
		return `https://sendpoll.com/${this.key}`
	}
}



// WEBPACK FOOTER //
// ./src/models/Poll.js